module.exports = __webpack_public_path__ + "img/notOk.94867fd6.svg";